import * as React from 'react';
import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { BlockHeader } from '../BlockHeader';
import { ContentWrapper } from '../ContentWrapper';
import { LandingBlock } from '../LandingBlock';

import { trackAdvantagesBlock } from './tracking';

import * as styles from './styles.css';

export const Advantages = () => {
  const onElementInViewPort = React.useCallback(() => {
    trackAdvantagesBlock();
  }, [trackAdvantagesBlock]);

  return (
    <ElementInViewport onVisibleFirst={onElementInViewPort}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>А в чем преимущества?</BlockHeader>
          <div className={styles['cards']}>
            <div className={styles['card']}>
              <h4 className={styles['card-title']}>Удобно</h4>
              <p className={styles['card-paragraph']}>
                Ипотечные предложения от&nbsp;6&nbsp;крупных банков страны не&nbsp;выходя&nbsp;из&nbsp;дома
              </p>
            </div>
            <div className={styles['card']}>
              <h4 className={styles['card-title']}>Бесплатно</h4>
              <p className={styles['card-paragraph']}>Никаких дополнительных сборов и&nbsp;комиссий</p>
            </div>
            <div className={styles['card']}>
              <h4 className={styles['card-title']}>Быстро</h4>
              <p className={styles['card-paragraph']}>
                Персональные ипотечные предложения за 10 минут. Даже если у вас есть одобренная ипотека, можно сравнить,
                что предложат другие&nbsp;банки
              </p>
            </div>
            <div className={styles['card']}>
              <h4 className={styles['card-title']}>Безопасно</h4>
              <p className={styles['card-paragraph']}>
                Каналы с банками защищены шифрованием. Третьи стороны не имеют доступ к вашим персональным&nbsp;данным
              </p>
            </div>
          </div>
        </ContentWrapper>
      </LandingBlock>
    </ElementInViewport>
  );
};
